import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Chip from "material-ui/Chip";
import Avatar from "material-ui/Avatar";
import TimePicker from "react-gradient-timepicker";
import {
  colors,
  btn,
  form,
  search as searchStyles,
} from "../../../../style/common/partnerStyle";

class CreateFixtureForm extends PureComponent {
  static propTypes = {
    match_details: PropTypes.object.isRequired,
    tournament_data: PropTypes.object,
    team_count: PropTypes.number,
    buddies: PropTypes.array,
    search: PropTypes.bool,
    buddy_search_list: PropTypes.array,
    submit_button_pressed: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onHandleChange: PropTypes.func.isRequired,
    onStartTimeChange: PropTypes.func.isRequired,
    onSearchBuddy: PropTypes.func.isRequired,
    onSetSearch: PropTypes.func.isRequired,
    onHandleRequestDelete: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  renderChip(data) {
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.props.onHandleRequestDelete(data.id)}
        style={{ margin: 4 }}
      >
        <Avatar
          id={data.id}
          src={
            data.photo === "http://www.sporthood.in/assets/img/avatar.png"
              ? data.photo
              : `https://api.sporthood.in/${data.photo}`
          }
        />
        {data.name}
      </Chip>
    );
  }

  render() {
    const {
      match_details,
      tournament_data,
      team_count,
      buddies,
      search,
      buddy_search_list,
      submit_button_pressed,
      onClose,
      onHandleChange,
      onStartTimeChange,
      onSearchBuddy,
      onSetSearch,
      onSubmit,
    } = this.props;

    return (
      <div
        style={{
          fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
          padding: "24px 20px",
        }}
      >
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <div
            style={{
              background: colors.surface,
              borderRadius: 12,
              boxShadow:
                "0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "18px 24px",
                borderBottom: `1px solid ${colors.border}`,
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: 16,
                  fontWeight: 700,
                  color: colors.text,
                }}
              >
                Create Fixture
              </h2>
              <button style={btn.cancel} onClick={onClose}>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Cancel
              </button>
            </div>

            <div style={{ padding: "20px 24px" }}>
              <div style={form.row}>
                <div style={form.labelWide}>Format *</div>
                <select
                  name="selected_format"
                  style={form.select}
                  value={match_details.selected_format}
                  onChange={onHandleChange}
                >
                  <option key={-1} value={null}>
                    Select format
                  </option>
                  {tournament_data &&
                    tournament_data.categories &&
                    tournament_data.categories.map((item, index) => (
                      <option key={index} value={item[0]}>
                        {item[1]}
                      </option>
                    ))}
                </select>
              </div>

              <div style={form.row}>
                <div style={form.labelWide}>No. of Teams *</div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: colors.text,
                    flex: 1,
                  }}
                >
                  {team_count}
                </div>
              </div>

              <div style={form.row}>
                <div style={form.labelWide}>
                  Match Duration *{" "}
                  <span style={{ fontSize: 11, color: colors.muted }}>
                    (min)
                  </span>
                </div>
                <input
                  type="number"
                  name="match_duration"
                  style={form.input}
                  placeholder="e.g. 90"
                  value={match_details.match_duration}
                  onChange={onHandleChange}
                />
              </div>

              <div style={form.row}>
                <div style={form.labelWide}>Start Time *</div>
                <div style={{ flex: 1 }}>
                  <TimePicker
                    time={match_details.start_time}
                    headerColor="#84888A"
                    color1="#84888A"
                    name="start_time"
                    className="timepicker"
                    placeholder="e.g. 09:00 AM"
                    onSet={onStartTimeChange}
                  />
                </div>
              </div>

              <div style={form.row}>
                <div style={form.labelWide}>Buddy Search *</div>
                <div style={form.searchWrap}>
                  <input
                    type="text"
                    name="mobile_no"
                    style={form.searchInput}
                    placeholder="Search by name or mobile"
                    value={match_details.mobile_no}
                    onChange={onHandleChange}
                  />
                  <button type="button" style={form.searchBtn} onClick={onSearchBuddy}>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                  </button>
                </div>
              </div>

              {search && (
                <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                  {buddy_search_list && buddy_search_list.length ? (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {buddy_search_list.map((x) => (
                        <button
                          key={x.id}
                          type="button"
                          style={{
                            ...btn.outline,
                            fontSize: 12,
                            padding: "6px 12px",
                          }}
                          onClick={() =>
                            onSetSearch(x.name, x.mobile_no, x.id)
                          }
                        >
                          {x.name}: {x.mobile_no}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <div style={searchStyles.notFound}>
                      <span style={searchStyles.notFoundText}>
                        Search buddy not found
                      </span>
                    </div>
                  )}
                </div>
              )}

              <div style={form.row}>
                <div style={form.labelWide}>Selected Buddies</div>
                <div style={{ flex: 1, display: "flex", flexWrap: "wrap" }}>
                  {buddies.map((data) => this.renderChip(data))}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "flex-end",
                  paddingTop: 16,
                  borderTop: `1px solid ${colors.border}`,
                  marginTop: 8,
                }}
              >
                <button style={btn.cancel} onClick={onClose}>
                  Cancel
                </button>
                <button
                  style={{
                    ...btn.primary,
                    opacity: submit_button_pressed ? 0.6 : 1,
                  }}
                  disabled={submit_button_pressed}
                  onClick={onSubmit}
                >
                  {submit_button_pressed ? "Creating…" : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateFixtureForm;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureScreen/CreateFixtureForm.js